import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  padding: 3rem 1.6rem 4rem;
  background: linear-gradient(180deg, #fff8ee 0%, #ffffff 55%, #fff6e8 100%);

  .logo {
    margin-bottom: 2rem;
  }
  header {
    display: flex;
    align-items: start;
  }

  .cta-wrap {
    margin-bottom: 3rem;
  }
`;

export const Content = styled.main`
  max-width: 110rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  h1 {
    font-size: 3.2rem;
    color: #212121;
    text-align: center;
    margin: 0;
  }

  .cta-wrap {
    display: flex;
    justify-content: center;
    margin-top: 0.8rem;
  }

  .cta-message {
    text-align: center;
    color: #3d2f1f;
    font-size: 1.8rem;
    margin: 0;
  }

  .intro {
    text-align: center;
    color: #666;
    font-size: 1.5rem;
    margin: -0.8rem 0 0;
  }

  .section-title {
    font-size: 2.2rem;
    color: #d97706;
    margin: 0;
  }
`;

export const MediaGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;

  .card {
    background-color: #fff;
    border: 1px solid #f1dfc7;
    border-radius: 1.2rem;
    padding: 1.4rem;
    box-shadow: 0 10px 30px rgba(217, 119, 6, 0.08);
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .badge {
    width: fit-content;
    padding: 0.3rem 0.9rem;
    border-radius: 999px;
    font-size: 1.2rem;
    font-weight: 700;
    color: #8a4f06;
    background: #fff0db;
    border: 1px solid #f3d3ab;
  }

  .card h2 {
    margin: 0;
    color: #2e2e2e;
    font-size: 1.8rem;
  }

  .description {
    margin: 0;
    color: #5f5f5f;
    font-size: 1.4rem;
    line-height: 1.45;
    min-height: 6.1rem;
  }

  .embed {
    width: min(100%, 32rem);
    aspect-ratio: 9 / 16;
    border: 0;
    border-radius: 0.8rem;
    background: #f6f6f6;
    margin: 0 auto;
    display: block;
  }

  .price-wrap {
    margin-top: 0.2rem;
    background: linear-gradient(135deg, #fff7eb 0%, #ffe2b9 100%);
    border: 1px solid #f0bc79;
    border-radius: 1rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .price-label {
    color: #8c520c;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-size: 1.1rem;
    font-weight: 700;
  }

  .price-value {
    font-size: 3.2rem;
    line-height: 1;
    font-weight: 900;
    color: #c45f00;
    text-shadow: 0 1px 0 #fff;
  }

  .buy-link {
    margin-top: 0.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 1.3rem;
    color: #fff;
    background: #2f7a00;
    border: 1px solid #2a6c00;
    border-radius: 0.8rem;
    padding: 1rem;
    transition: background-color 0.2s ease-in-out;
  }

  .buy-link:hover {
    background: #266300;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;

    .description {
      min-height: auto;
    }
  }
`;
